exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_markdownEditorContainer__1G5rk{position:relative;width:100%}.style_restrictedHeight__kHLAa{max-height:15rem}.style_iconButton___5HNj{width:2rem!important;min-width:2rem!important}.style_iconButton___5HNj:hover span{opacity:1}.style_iconButton___5HNj span{padding-left:0!important;padding-right:0!important;opacity:.6}.style_markdownSupported__2F-aV{padding-right:.25rem}.style_iconButtonContainer__1pHWS{display:flex;flex-direction:row;justify-content:flex-end;background:hsla(0,0%,60%,.08);border:.0625rem solid #ccc;border-bottom:0}.style_textarea__vr5fk{max-width:inherit!important}", ""]);

// exports
exports.locals = {
	"markdownEditorContainer": "style_markdownEditorContainer__1G5rk",
	"restrictedHeight": "style_restrictedHeight__kHLAa",
	"iconButton": "style_iconButton___5HNj",
	"markdownSupported": "style_markdownSupported__2F-aV",
	"iconButtonContainer": "style_iconButtonContainer__1pHWS",
	"textarea": "style_textarea__vr5fk"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/form/MarkdownEditor/style.less
// module id = 1724
// module chunks = 8